module.exports = __webpack_public_path__ + "img/IMG_2368_L_BlackMatted.786d6129.jpg";